import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'manage-cdn-component',
  templateUrl: './manage-cdn.component.html',
  styleUrls: ['./manage-cdn.component.scss'],
})
export class ManageCDNComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public httpService: HttpService,
    public gridService: GridService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.columnsSettings = [
      { key: 'id', label: 'ID', width: 80, filterType: 'INPUT', primaryKey: true },
      { key: 'fileName', label: 'FILE_URL', width: 400, filterType: 'INPUT' },
      { key: 'originalName', label: 'FILE_NAME', width: 350, filterType: 'INPUT' },
      { key: 'fileNype', label: 'TYPE', width: 80 },
      { key: 'fileSize', label: 'SIZE_KB', width: 100 },
      { key: 'updatedAt', label: 'DATE', filterType: 'INPUT' },
      {
        key: 'multiBitrate',
        label: 'MULTI_BITRATE',
        width: 130,
        filterType: 'SELECT',
        parseTooltipFunction: this.gridService.parseBooleanTooltip,
        parseFunction: this.gridService.parseBoolean,
        featureFlag: 'cdn_media_transcoding',
      },
    ];

    this.isLoading = false;
    this.isError = false;
    this.subscriptions = [];
  }

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.initialize();
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_DATA_UPDATED') {
          this.initialize();
        }
      })
    );
    this.sharedService.setPageTitle('MANAGE_CDN');
  }

  initialize(): void {
    if (this.userService.getFeatureState('display_cdn')) {
      this.subscriptions.push(
        this.sharedService.getMessagesBus().subscribe((response: any) => {
          if (
            response.type === 'CDN_FILE_UPLOAD' ||
            response.type === 'CDN_FILE_DELETE' ||
            response.type === 'CDN_FILE_UPDATE'
          ) {
            this.getCdnFiles();
          }
        })
      );
      this.getCdnFiles();
    } else {
      this.router.navigate(['/']).then(() => {
        return;
      });
    }
  }

  getCdnFiles(): void {
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('cdn_files/getCdnFiles').subscribe(
        (response) => {
          const data = response;
          let fileLink: string;
          const isAdmin: boolean = this.userService.isAdmin();
          let fileExt: string;
          const defaultServingDomain: string = this.userService.getDefaultDomainName();
          for (let i = 0; i < data.length; i++) {
            fileLink = `//c.${defaultServingDomain}/${this.userService.networkData.networkId}/${data[i].originalName}`;
            data[i].fileName = fileLink;
            data[i].$$link = fileLink;
            fileExt = data[i].originalName.split('.').pop().toLowerCase();
            if (isAdmin || (!isAdmin && fileExt !== 'js')) {
              data[i].$$actions = [{ type: 'DELETE', link: false }];
            }
            data[i].fileNype = +data[i].fileNype;
            if (data[i].fileNype === 3 && data[i].originalName.includes('.mrss')) {
              //Add here new conditions for update cdn file
              data[i].$$actions.push({ type: 'EDIT_ICON', link: false, linkOverride: '' });
            }
          }
          this.data = data;
          this.isLoading = false;
        },
        () => {
          // Display the error message
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  openUploadModal(): void {
    this.modalsService.showModal({
      component: 'cdn-file-upload',
      title: this.dictionaryService.get('CDN_FILE_UPLOAD'),
    });
  }

  openMRSSUpdateModal($event): void {
    this.modalsService.showModal({
      component: 'cdn-file-update',
      title: this.dictionaryService.get('CDN_FILE_MRSS_UPDATE'),
      data: $event,
    });
  }

  onDeleteClick($event): void {
    this.modalsService.showModal({
      component: 'cdn-file-delete',
      title: this.dictionaryService.get('CDN_FILE_DELETE'),
      data: $event,
    });
  }

  onUpdateClick($event): void {
    if ($event.fileNype == '3') {
      this.openMRSSUpdateModal($event);
    } else {
      //currently for other types we dont have generic update modal.
    }
  }
}
